// extracted by mini-css-extract-plugin
export var container = "_10e-0";